import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Rx';
import {NestApiProvider} from "../../nest-api";
import {
  RequestApproveDto,
  RequestCountMyApprovalDto,
  RequestCountMyRequestDto,
  RequestListApprovalDto,
  RequestMyApprovalDto,
  RequestMyRequestDto,
  ResponseApproveDto,
  ResponseMyRequestDto,
  ResponseRequestInboxDto
} from '../dto/request-inbox.dto';
import {ResponseData} from "../../nest-responses";


@Injectable()
export class RequestInboxApi {

  private service: string = '';
  private model: string = 'sf6s/requestInbox';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public myRequest(payload: RequestMyRequestDto): Observable<ResponseRequestInboxDto<ResponseMyRequestDto>> {
    const method: string = 'GET';
    const func: string = 'myRequest';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseRequestInboxDto<ResponseMyRequestDto>>(method, url, params, urlParams, body);
  }

  public myApproval(payload: RequestMyApprovalDto): Observable<ResponseRequestInboxDto<any>> {
    const method: string = 'GET';
    const func: string = 'myApproval';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseRequestInboxDto<any>>(method, url, params, urlParams, body);
  }

  public countMyRequest(payload: RequestCountMyRequestDto): Observable<ResponseData<number>> {
    const method: string = 'GET';
    const func: string = 'countMyRequest';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<number>>(method, url, params, urlParams, body, null, null, null, false);
  }

  public countMyApproval(payload: RequestCountMyApprovalDto): Observable<ResponseData<number>> {
    const method: string = 'GET';
    const func: string = 'countMyApproval';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<number>>(method, url, params, urlParams, body, null, null, null, false);
  }

  public listApproval(payload: RequestListApprovalDto): Observable<ResponseRequestInboxDto<any>> {
    const method: string = 'GET';
    const func: string = 'listApproval';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseRequestInboxDto<any>>(method, url, params, urlParams, body);
  }

  public approve(payload: RequestApproveDto): Observable<ResponseData<ResponseApproveDto>> {
    const method: string = 'GET';
    const func: string = 'approve';
    const params: any = {};
    const urlParams: any = payload || {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<ResponseApproveDto>>(method, url, params, urlParams, body);
  }


}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-all-in-one/services/request-inbox.api.ts